import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import {default as FFontPicker} from 'font-picker-react';
import {Col} from 'react-bootstrap';

export default class FontPicker extends React.Component {
  render() {
    return (
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Font
        </Form.Label>

        <Col sm={'2'}>
          <FFontPicker
            apiKey={'AIzaSyAlV1ZeFbk96XTQ_mXLvzbaMMTPK5cH7Cs'}
            activeFontFamily={this.props.font}
            limit={200}
            onChange={(font) => this.props.onChange(font.family)}
          />
        </Col>
        <Col sm={'2'}>
          <p className="apply-font" style={{paddingLeft: '20px'}}>
            1234567890
          </p>
        </Col>
      </Form.Group>
    );
  }
}
